import { updateSensorParameter } from "@/api/device/sensor";
import { updateMonitorParameter } from "@/api/monitor-object/monitor-parameter";
import { Emit_Event } from "@/enums/emit-event";
import TnInput from "@/global/components/input/tn-input";
import TnMessage from "@/global/components/message";
import { SensorParameter } from "@/global/interface/device/sensor";
import { MonitorParameter } from "@/global/interface/monitor-object/monitor-parameter";
import { emitter } from "@/global/listeners";
import { Transfer2BackEndScale } from "@/global/utils/unit-type";
import { useEffect, useState } from "react";
import { useParams } from "react-router";

interface Iprops {
    param: SensorParameter
    updateParam?: (par: SensorParameter) => void
}

export default function SensorParameterWarningSetting(props: Iprops) {
    const [item, setItem] = useState<SensorParameter>();

    useEffect(() => {
        setItem(props.param);
    }, [props.param])

    // 更新参数阈值
    const updateParameter = (id: number, data: SensorParameter) => {
        updateSensorParameter(id, data).then(res => {
            props.updateParam(item);
            emitter.emit(Emit_Event.LINE_CHART_UPDATE)
            TnMessage.success("更新成功");
        }).catch(err => {
            TnMessage.error("更新失败");
        })
    }

    if (!item) {
        return (
            <div></div>
        )
    }

    return (
        <div className="param">
            <div className="name ellipsis" title={`${item.name}${item.unit || ''}`}>{item.name}{item.unit || ''}</div>
            <div className="cell"><TnInput
                className="blue-input"
                value={item.t2Dis}
                onTextChange={(value) => {
                    const reg = /^-?\d*(\.\d*)?$/;
                    if ((!isNaN(+value) && reg.test(value)) || value === '' || value === '-') {
                        setItem({ ...item, t2Dis: value, t2: value })
                    }
                }}
                onBlur={(value) => {
                    const reg = /^-?\d*(\.\d*)?$/;
                    if ((!isNaN(+value) && reg.test(value)) || value === '' || value === '-') {
                        let scale = Transfer2BackEndScale(item.unit);
                        let t2 = scale * (+value)
                        updateParameter(item.id, { t2: t2 })
                    }
                }}
            /></div>
            <div className="cell sec"><TnInput
                className="blue-input"
                value={item.t3Dis}
                onTextChange={(value) => {
                    const reg = /^-?\d*(\.\d*)?$/;
                    if ((!isNaN(+value) && reg.test(value)) || value === '' || value === '-') {
                        setItem({ ...item, t3Dis: value, t3: value })
                    }
                }}
                onBlur={(value) => {
                    const reg = /^-?\d*(\.\d*)?$/;
                    if ((!isNaN(+value) && reg.test(value)) || value === '' || value === '-') {
                        let scale = Transfer2BackEndScale(item.unit);
                        let t3 = scale * (+value)
                        updateParameter(item.id, { t3: t3 })
                    }
                }}
            /></div>
            <div className="cell third"><TnInput
                className="blue-input"
                value={item.t4Dis}
                onTextChange={(value) => {
                    const reg = /^-?\d*(\.\d*)?$/;
                    if ((!isNaN(+value) && reg.test(value)) || value === '' || value === '-') {
                        setItem({ ...item, t4Dis: value, t4: value })
                    }
                }}
                onBlur={(value) => {
                    const reg = /^-?\d*(\.\d*)?$/;
                    if ((!isNaN(+value) && reg.test(value)) || value === '' || value === '-') {
                        let scale = Transfer2BackEndScale(item.unit);
                        let t4 = scale * (+value)
                        updateParameter(item.id, { t4: t4 })
                    }
                }}
            /></div>
        </div>
    )
}